const { REACT_APP_ENV } = process.env;

// 接口Root
// export const apiRoot = REACT_APP_ENV === 'development' ? 'https://material-design-platform.devindata.com/api' : 'https://material-design-platform.devindata.com/api';
export const apiRoot1 = 'http://localhost:3030/api'
// export const apiRoot = window.origin === 'http://localhost:3000' ? 'http://localhost:3030/api' : `${window.origin}/api`

export const apiRoot = window.origin === 'http://localhost:3000' ? 'http://localhost:3030/api' : `${window.origin}/api`

// export const propsAPI='http://localhost:8001/api'
export const propsAPI='https://ccpd.devindata.com/api'

// 网站程序名称
export const webTitle = '工业计算平台';

// 应用权限登录名称
// export const appLoginName='煤化工物性数据库';

const preFix = 'INCP';//常数字段前缀

// 主题缓存字段名
export const themsField = `${preFix}_theme`;

// 用户信息缓存字段
export const userInfoField = `${preFix}_userInfo`;

export const themes = [
  {
    name: '浅色',
    code: 'light'
  },
  {
    name: '暗色',
    code: 'dark'
  },
]

export const Colors = {
  BODY: '#FFFFFF',
  PRIMARY: '#024DC4',
  SECONDARY: '#002bc6',
  TEXT: '#1b6ae7',
  TEXT2: '#8d8e8f',
  SUCCESS: '#00B42A',
  WARNING: '#FF7D00',
  DANGER: '#F53F3F',
  NEUTRAL_1: '#1D2129',
  NEUTRAL_2: '#4E5969',
  NEUTRAL_3: '#86909C',
  NEUTRAL_4: '#C9CDD4',
  NEUTRAL_5: '#F2F3F5',
};